/**
 * Galerie produit — pilotage des vidéos
 *
 * Le thème ne fait que démarrer la vidéo, puis laisse la barre de contrôle
 * native prendre le relais. Cette barre étant désactivée, on ajoute ici :
 *
 * 1. un clic sur la vidéo la met en pause ou la relance ;
 * 2. à la fin, elle s'arrête et revient au début — elle ne repart que
 *    si la personne clique ;
 * 3. elle s'arrête si elle sort complètement de l'écran.
 *
 * Aucun démarrage automatique : la vidéo ne part QUE sur un clic, sur le
 * bouton lecture rond du thème (shadow part « play-button »), affiché tant
 * que la vidéo ne tourne pas (voir base.css).
 */
(() => {
  const SELECTEUR = '.product-gallery__media video-media';

  /** Le premier clic est déjà géré par le thème : on ne double pas l'action. */
  const dejaChargee = (media) => media.hasAttribute('loaded');

  const observees = new WeakSet();

  // Une vidéo qui quitte l'écran (défilement de la page, changement de
  // diapositive) s'arrête : elle ne continue pas à tourner dans le vide.
  const observateur = new IntersectionObserver(
    (entrees) => {
      entrees.forEach(({ target, intersectionRatio }) => {
        if (intersectionRatio === 0 && typeof target.pause === 'function') {
          target.pause();
        }
      });
    },
    { threshold: 0 }
  );

  const recenser = () => {
    document.querySelectorAll(SELECTEUR).forEach((media) => {
      if (observees.has(media)) return;

      observees.add(media);
      observateur.observe(media);
    });
  };

  recenser();
  document.addEventListener('DOMContentLoaded', recenser);
  document.addEventListener('shopify:section:load', recenser);

  // La galerie est reconstruite à chaque changement de variante.
  let recensementEnAttente;
  new MutationObserver(() => {
    clearTimeout(recensementEnAttente);
    recensementEnAttente = setTimeout(recenser, 100);
  }).observe(document.documentElement, { childList: true, subtree: true });

  document.addEventListener('click', (event) => {
    const media = event.target.closest?.(SELECTEUR);

    if (!media || !dejaChargee(media) || typeof media.play !== 'function') return;

    if (media.playing) {
      media.pause();
    } else {
      media.play();
    }
  });

  // « ended » ne remonte pas : on l'écoute en phase de capture.
  document.addEventListener(
    'ended',
    (event) => {
      const media = event.target.closest?.(SELECTEUR);

      if (!media) return;

      // Rend la main au bouton lecture et repart du début au prochain clic.
      media.removeAttribute('playing');
      event.target.currentTime = 0;
    },
    true
  );
})();
